'use client';

import Slider from 'react-slick';
import config from 'config';
import { defaultSettings } from 'constant';
import { StaticImageData } from 'next/image';

import { Box, Link } from '@chakra-ui/react';

import { StaticMediaImage } from 'ui/StaticMediaImage';

const {
  dashboard: { sidebar }
} = config;

const PromoBanner = () => (
  <Box
    w='100%'
    justifyContent='flex-end'
    alignSelf='center'
    marginBottom='20px'
    sx={{
      '*': {
        outline: 'none'
      }
    }}
  >
    <Slider
      {...defaultSettings}
      fade
      speed={2000}
      adaptiveHeight
      variableWidth={false}
    >
      {sidebar?.promoBanners.map(
        ({ img, url }: { img: StaticImageData; url: string }) => (
          <Box w='100%' h='100%' key={`${img.src}-${url}`} position='relative'>
            <StaticMediaImage
              src={img}
              alt={url ? `Promotional banner — ${url}` : 'Promotional banner'}
              priority
              style={{
                objectFit: 'cover',
                width: '100%',
                height: '100%',
                borderRadius: 6
              }}
            />
            {url && (
              <Link
                href={url}
                position='absolute'
                top={0}
                left={0}
                bottom={0}
                right={0}
                cursor='pointer'
                target='_blank'
                outline='none !important'
                draggable={false}
              />
            )}
          </Box>
        )
      )}
    </Slider>
  </Box>
);

export default PromoBanner;
